import { Action, INIT, MetaReducer, UPDATE } from '@ngrx/store';

export function authMetaReducer(reducer: any): any {
    return (state: any, action: Action) => {

        if (action.type === INIT) {
            const storageToken = localStorage.getItem("token");
            if(storageToken)
            {
                const token = JSON.parse(storageToken);
                if (token) {
                    if(!state)
                    {
                        state = {
                            auth: {
                                token
                            }
                        }
                    }
                }
            }
        }

        const nextState = reducer(state, action);
        return nextState;
    };
}

export const metaReducers: MetaReducer<any>[] = [authMetaReducer];